import React, { Component } from 'react';
import fontawesome from '@fortawesome/fontawesome'

import brands from '@fortawesome/fontawesome-free-brands'
import { faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid'
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Projects from './components/Projects';
import {Base, app } from './base'
import Login from './components/Login'
import Loading from './components/Loading'
import Logout from './components/Logout'
import { BrowserRouter, Route, hashHistory, Redirect} from 'react-router-dom'
import PrivacyPolicy from './components/privactPolicy'
import Blog from './components/blog/Blog'
import Store from './components/store/Store'
import { Colors } from "@blueprintjs/core"
import ReactGA from 'react-ga'
import createHistory from 'history/createBrowserHistory'
import User from './components/User'
import Notes from './components/Notes/Notes'

ReactGA.initialize('UA-116154236-1')

fontawesome.library.add(brands, faCheckSquare, faCoffee);

function AuthenticatedRoute({component:Component, authenticated, ...rest}) {
  return (
    <Route
    {...rest}
    render={(props) => authenticated === true
      ? <Component {...props} {...rest} />
      : <Redirect to={{pathname: '/login', state : {from: props.location}}} />
    } />
  )
}


class App extends Component {
  constructor() {
    super()
    this.setCurrentUser= this.setCurrentUser.bind(this)
    this.state = {
      authenticated: false,
      loading:true,
      currentUser: null
    }
  }

  setCurrentUser(user) {
    if (user) {
      this.setState({
        currentUser: user,
        authenticated: true
      })
    } else {
      this.setState({
        currentUser: null,
        authenticated: false
      })
    }
  }



componentWillMount() {
  this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
    if (user) {
      this.setState({
        currentUser: user,
        authenticated:true,
        loading:false
      })
    } else {
      this.setState({
        currentUser: null,
        authenticated:false,
        loading:false
      })
    }
  })

}

componentWillUnmount() {
  this.removeAuthListener()

}

  render() {


    if (this.state.loading === true) {
      return (
        <Loading />
      )
    }
    return (

      <div style = {{maxWidth: "1160px", margin: "0 auto", minHeight: "60em"}}>
        <BrowserRouter>
          <div>
          <Header authenticated = {this.state.authenticated}/>
          <br/>
            <div style={{padding:"1em"}}>
              <Route exact path="/" component={Home} />
              <Route exact path="/login" render={(props) => {
                  return <Login setCurrentUser={this.setCurrentUser} {...props} />
                }} />
              <Route path="/home" component={Home} />
              <Route path="/about" component={About} />
              <Route path="/contact" component={Contact} />
              <Route exact path="/projects" component={Projects} />
              <Route exact path="/logout" component={Logout} />
              <Route currentUser = {this.state.currentUser} exact path="/blog" component={Blog} />
              <Route exact path="/store" component={Store} />
              <AuthenticatedRoute 
              exact path ='/notes' 
              component={Notes}
              authenticated = {this.state.authenticated} />
              <Route exact path="/privacy" component={PrivacyPolicy} />
              <AuthenticatedRoute 
              exact path ='/user' 
              component={User}
              authenticated = {this.state.authenticated} />
              <Route exact path="/privacy" component={PrivacyPolicy} />
            </div>
            <Footer />
          </div>     
        </BrowserRouter>

      </div>

    );
  }
}

export default App; 


// WEBPACK FOOTER //
// ./src/App.jsx